<template>
  <div class="news">
    <el-row :gutter="isPc != 3 ? '30' : 0" class="news-list">
      <el-col :span="isPc != 3 ? 8 : 24" v-for="item in newsListRes" :key="item.newsId">
        <div class="news-item" @click="toDetails(item)">
          <img :src="item.newsImage" class="news-img hand" />
          <div class="news-info">
            <!-- <div class="items-center justify-between">
              <span class="bg-red text-white font14">{{ item.newstype }}</span>
              <time class="text-grey font14">{{ item.releaseTime }}</time>
            </div> -->
            <h3 class="text-black font18">
              {{ item.newsTitle }}
            </h3>
            <p v-html="item.brief"></p>
            <div class="tag">
              <span>{{ item.tag }}</span>
              <em>{{ item.linkMagazine ? ' · ' : '' }}</em>
              <em>{{ item.linkMagazine ? L('发布于' + item.linkMagazine) : '' }}</em>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- <el-row :gutter="0" v-if="isPc != 1">
      <el-col :span="24" v-for="item in newsListRes" :key="item.newsId">
        <div class="news-item" @click="toDetails(item.newsId)">
          <img :src="item.newsImage" class="news-img hand" />
          <div class="news-info">
            <div class="items-center justify-between">
              <span class="bg-red text-white font14">{{ item.newstype }}</span>
              <time class="text-grey font14">{{ item.releaseTime }}</time>
            </div>
            <h3 class="text-black font18">
              {{ item.newsTitle }}
            </h3>
          </div>
        </div>
      </el-col>
    </el-row> -->
    <div v-if="ispagination" class="justify-center" style="padding-bottom: 50px">
      <pagination :current-page="pageNum" :page-size="pageSize" :total="total" @changeSize="changeSize" />
    </div>
  </div>
</template>

<script>
import pagination from "./pagination.vue";
import { getNewsList } from "@/assets/api/news.js";
import { mapState } from "vuex";

export default {
  components: {
    pagination,
  },
  props: {
    typeId: {
      type: String,
      default: "",
    },
    ispagination: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState(["isPc"]),
  },
  data() {
    return {
      newsListRes: [],
      total: 0,
      pageNum: 1,
      pageSize: 6,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getNewsList({
        orderByColumn: "releaseTime",
        isAsc: "desc",
        typeId: this.typeId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        slideshow: 0,
      }).then((res) => {
        // console.log(res.data);
        this.total = res.data.total;
        this.newsListRes = res.data.rows.map((item) => {
          item.newsImage = !/^http/.test(item.newsImage)
            ? this.$imgUrl + item.newsImage
            : item.newsImage;
          item.tag = item.tag.split('|').join(' · ');
          return item;
        });
      });
    },
    changeSize(e) {
      console.log(e);
      this.pageNum = e;
      this.init();
    },
    toDetails(item) {
      if (item.url) {
        window.open(item.url, "_blank");
      } else {
        localStorage.setItem('newsId', item.newsId);
        let path = item.seoUrl ? item.seoUrl : item.newsId
        this.$router.push({
          path: `/${path}.html`,
        });
      }
    },
    generateSlug(title) {
      // 将标题中的空格替换为连字符
      let slug = title.toLowerCase().replace(/\s+/g, '-');
      // 将连字符替换为单个连字符
      slug = slug.replace(/-+/g, '');
      slug = slug.replace(/:+/g, '');
      return slug;
    },
  },
};
</script>

<style lang="less" scoped>
.news {
  margin-top: 40px;

  .news-list {
    margin-bottom: 60px;
    border-bottom: 1px solid #E5E5EA;
    padding-bottom: 30px;
  }

  .news-item {
    background: #fff;
    margin-bottom: 30px;
    cursor: pointer;

    img {
      width: 100%;
      height: 244px;
      border-radius: 8px;
      object-fit: cover;
    }

    .news-info {
      margin-top: 16px;

      span {
        font-family: NotoSansCJKTC;
        font-weight: bold;
        line-height: 1.71;
        letter-spacing: 0.7px;
        padding: 2px 8px;
      }

      time {
        font-family: NotoSansCJKTC;
        font-weight: bold;
        line-height: 1.71;
        letter-spacing: 0.7px;
      }

      h3 {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 24px;
        color: #2C2C2E;
        line-height: 31px;
        height: 62px;
        text-align: left;
        font-style: normal;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }

      p {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #636366;
        line-height: 21px;
        text-align: justify;
        font-style: normal;
        margin-top: 8px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
        height: 42px;
      }

      .tag {
        margin-top: 16px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #AEAEB2;
        line-height: 19px;
        text-align: left;
        font-style: normal;

        em {
          color: #E2291E;
        }
      }
    }

    &:hover {
      h3 {
        color: #E2291E;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .news {
    margin: 0;

    .news-list {
      border-bottom: none;
    }

    .news-item {
      background: #fff;
      margin-bottom: 0;

      padding: 20px 0;
      border-bottom: 1px solid #E5E5EA;

      img {
        width: 100%;
        height: 225px;
        object-fit: cover;
      }

      .news-info {
        padding: 0;
        margin-top: 12px;

        .tag {
          margin-top: 6px;
        }

        span {
          font-family: MicrosoftYaHei;
          font-size: 12px;
          color: #AEAEB2;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          padding: 0;
        }

        time {
          font-family: NotoSansCJKTC;
          font-weight: bold;
          line-height: 1.71;
          letter-spacing: 0.7px;
        }

        h3 {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 18px;
          color: #2C2C2E;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          height: 48px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/story-list.vue